import React, { Component } from "react";
import MainText from "./MainText";
import { connect } from "react-redux";
import Toolbar from './Toolbar';

let index;
let decisionData = {};

class DecisionLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      decisionStarted: false,
      selected: [],
      feedback: []
    };
  }
  componentDidMount(){
    index = this.props.decisionIndex;
  }
  advance = () => {
    // if we have data, add it here.
        // we need to get the object back, so search for it here.
        for (let i = 0; i < this.state.selected.length; i++){
            let condition = this.state.selected[i].conditions;
            let nextIndex = (parseInt(index) + 1).toString();
            console.log('condition type = ' + condition.type);
            // if we have no conditions, just add to the index and move our data to redux
              if (condition.type === null) {
                index = nextIndex;
               this.props.dispatch({ type: 'ADD_DECISION_DATA', payload: {
                  question: decisionData[index].question,
                  index: index,
                  choice: this.state.selected[i].text, 
                  feedback: this.state.selected[i].feedback}
                });
               this.setState({
                 decisionStarted: true, selected: [], feedback: []
               })
              } else {
                // otherwise, we have some specific actions to take
                if (condition.type === "dispatch") {
                  this.props.dispatch({ type: 'ADD_DECISION_DATA', payload: {
                    question: decisionData[index].question,
                    index: index,
                    choice: this.state.selected[i].text,
                    feedback: this.state.selected[i].feedback}
                  });
                 this.setState({
                   decisionStarted: true, selected: [], feedback: []
                 })
                 this.props.dispatch({ type: condition.command });
                    index = condition.index
                } else if (condition.type === "end"){
                  this.props.dispatch({ type: 'ADD_DECISION_DATA', payload: {
                    question: decisionData[index].question,
                    index: index,
                    choice: this.state.selected[i].text,
                    feedback: this.state.selected[i].feedback}
                  });
                 this.setState({
                  decisionStarted: true, selected: [], feedback: []
                 });
                 this.props.dispatch({type:'CLOSE_DECISION'})
                } 
              }
          }
    
        }
    getPrevious = () => {
      let lessonHistory = this.props.lessonHistory;
      let thisScene = lessonHistory.filter(
        (scene) => scene.current_scene === this.props.activeScene.scene_number
      );
      this.props.dispatch({
        type: "SET_ACTIVE_SCENE",
        payload: this.props.lessonData[thisScene[0].previous_scene],
      });
    };
    handleChange = (event, option) => {
      let feedbackDisplay = [];
      if(option.feedback.length > 0){
        feedbackDisplay.push(option.feedback);
      }
      let selected = [{text: event.target.value, conditions: option.conditions, feedback: option.feedback}]
      this.setState({...this.state, selected: selected, feedback: feedbackDisplay})
    }
    
  handleMultipleChange = (event, option) => {
    let choices = this.state.selected;
    let feedbackDisplay = this.state.feedback;
    if(option.feedback.length > 0){
      feedbackDisplay.push(option.feedback);
    }
    choices.push({text: event.target.value, conditions: option.conditions, feedback: option.feedback});
    this.setState({...this.state, selected: choices, feedback: feedbackDisplay});
  }
  handlePrint = () => {
    window.print();
  };
  startDecision = () => {
    this.setState({
      decisionStarted: true,
    });
  };
  tryAgain = () => {
    if (window.confirm('Are you sure you want to try again? Your current responses will be erased.')){
      this.props.dispatch({type: "RESET_USER_DECISION_DATA", payload: {"1": {question: '', choice: [] }, "2": {question: '', choice: [] }, "3": {question: '', choice: [] }, "4": {question: '', choice: [] }, "5": {question: '', choice: [] }, "6": {question: '', choice: [] }, "7": {question: '', choice: [] }, "8": {question: '', choice: [] }, "9": {question: '', choice: [] }}});
      this.props.dispatch({type: "RESET_MEANING_DECISION_DATA"});
      this.props.dispatch({type: "RESET_INTERPERSONAL_DECISION_DATA"});
      this.props.dispatch({type: "RESET_POLICY_DECISION_DATA"});
      this.props.dispatch({type: 'OPEN_DECISION'})
    }
  
  }
  render() {
    if (this.props.activeLesson.id === 2){
      decisionData = this.props.interpersonalDecisionData;
    } else if (this.props.activeLesson.id === 4){
      decisionData = this.props.sourceDecisionData
    } else if (this.props.activeLesson.id === 1){
      decisionData = this.props.policyDecisionData
    }
    return (
      <div className="layout-page">
        <div className="flex-box flex-center">
          <div className="column-lg-10 column-md-12 column-sm-12">
            {this.props.activeScene.title !== null && (
              <h2><span className="title">{this.props.activeScene.title}</span></h2>
            )}
          </div>
        </div>
        {!this.state.decisionStarted && !this.props.decisionState && (
          <div>
            <div className="flex-box flex-center">
              <div className="column-lg-10 column-md-12 column-sm-12 text-spotlight text-blue">
                {this.props.activeScene.text.map((text, i) => {
                  return <MainText className={`none`} text={text} key={i} />;
                })}
              </div>
            </div>
            <div className="flex-box flex-center nav-buttons">
              <button className="button" onClick={()=>this.getPrevious()}>Previous</button>
              <button className="button" onClick={() => this.startDecision()}>
                Start
              </button>
            </div>
          </div>
        )}
        <div className="flex-box flex-center">
        {this.state.decisionStarted && !this.props.decisionState && (
          <div className="column-lg-10 column-md-12 column-sm-12 text-spotlight text-blue">
            <MainText
              className={`none`}
              text={decisionData[index].question}
            />
            <div className="decision-area flex-box">
            {decisionData[index].options.map((option, i) => {
              return (
                <div key={i} className="column-lg-4 column-md-4 column-sm-4">
                    <div className="answer-select">
                  {decisionData[index].multipleSelect && <input
                    type="checkbox"
                    value={option.text}
                    onChange={(event) => this.handleMultipleChange(event, option)}
                    checked={this.state.selected.find(element => element.text === option.text)}
                  />}
                  {!decisionData[index].multipleSelect && <input
                    type="radio"
                    id={option.text} name="choice"
                    value={option.text}
                    onChange={(event) => this.handleChange(event, option)}
                    checked={this.state.selected.find(element => element.text === option.text)}
                  />}
                  <label className="label" htmlFor={option.text}>{option.text}</label>
             </div>
                </div>
              );
            })}
                 <div className="feedback-div">
                  {this.state.feedback.length > 0 && <h3>Feedback:</h3>}
            {this.state.feedback.map((feedback, i) => {
              return(
                  <p key={i} className="true feedback">{feedback}</p>
              )
            })}
              </div>
            </div>
            {this.state.selected.length !== 0 &&<div className="flex-box flex-end"> <button
              className="button button-small"
              onClick={() => this.advance()}
            >
              next
            </button></div>}
          </div>
        )}
        </div>

      {this.props.decisionState && <div>
          <div className="flex-box flex-end">
          <p onClick={() => this.handlePrint()}>
              <span className="download-div">print</span>
            </p>
            </div>
            <div className="flex-box flex-center">
            <div className="col-sm-12 col-lg-10 col-md-10">
            <h3>Your choices:</h3>
            <div className="decision-feedback">
            <ol>
            {Object.keys(this.props.userDecisionData).map((data,i)=>{
              if (this.props.userDecisionData[data].question.length > 0){
                return(
                  <li key={i}>{this.props.userDecisionData[data].question}
                  <ul>
                  {this.props.userDecisionData[data].choice.map((choice, j) => {
                        return(<div key={j}><em>You chose:</em> {choice.choice}<ul><li><em>Feedback:</em> {choice.feedback}</li></ul></div>)
                      })}
                  </ul>
                     
                  </li>
                )} else {
                  return false;
                }
            })}
            </ol>
            </div>
            </div>
            </div>
        <div className="flex-box flex-center decision-area">
             <button className="button" onClick={()=>this.tryAgain()}>Try again</button> 
        </div>
            <Toolbar/>
          </div>}
            
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  activeScene: state.activeScene,
  sourceDecisionData: state.sourceDecisionData,
  userDecisionData: state.userDecisionData,
  lessonData: state.lessonData,
  lessonHistory: state.lessonHistory, 
  interpersonalDecisionData: state.interpersonalDecisionData,
  activeLesson: state.activeLesson,
  policyDecisionData: state.policyDecisionData,
  decisionState: state.decisionState,
  decisionIndex: state.decisionIndex
});
export default connect(mapStateToProps)(DecisionLayout);
